const LISTAR_TRATATIVAS_OPCOES = (state, payload) =>  {
  state.tratativas_opcoes = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_TRATATIVA_OPCAO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const ATUALIZAR_TRATATIVAS_OPCOES = (state, payload) => {
  state.items = state.items.map(tratativa => {
    if(tratativa.id === payload.id) {
      return payload;
    }
    return tratativa
  })
}

export {
  LISTAR_TRATATIVAS_OPCOES,
  BUSCANDO,
  INSERIR_TRATATIVA_OPCAO_SELECIONADO,
  ATUALIZAR_TRATATIVAS_OPCOES
}